
















import { Component, Prop } from "vue-property-decorator";
import { DialogComponent } from "vue-modal-dialogs";

import ShippingManifestCreateForm from "./ShippingManifestCreateForm.vue";

@Component({
  components: { ShippingManifestCreateForm },
})
export default class CreateShippingManifestDialog extends DialogComponent<boolean> {
  @Prop({ required: true })
  public readonly factoryId!: string;

  @Prop({ required: true })
  public readonly bulkShipmentsIds!: string[];
}
